export const API = {
    GET_ECOM_SALES_ORDER: '/api/v1/SalesInventory/GetEcomSalesOrder',
    GET_ECOM_SALES_ORDER_ITEMS: '/api/v1/SalesInventory/GetEcomSalesOrderItems',
    CREATE_CLICK_POST_ORDER: '/api/v1/EcomOrderProcessing/CreateClickPostOrder',
    Get_Make_To_Order_ItemBy_Sales_Order: 'api/v1/EcomOrderProcessing/GetMakeToOrderItemBySalesOrder',
    Add_Ecom_Make_To_Order_Product_In_Sales_Orders: '/api/v1/EcomOrderProcessing/AddEcomMakeToOrderProductInSalesOrders'
}